import React from "react";
import {
  Dialog,
  DialogContent,
  FormControl,
  Autocomplete,
  TextField,
  Box,
  Typography,
} from "@mui/material";
import "./TranslateDialog.css";

const languages = [
  { code: "arabic", label: "Arabic", native: "العربية" },
  { code: "bengali", label: "Bengali", native: "বাংলা" },
  { code: "chinese", label: "Chinese (Simplified)", native: "简体中文" },
  { code: "dutch", label: "Dutch", native: "Nederlands" },
  { code: "english", label: "English", native: "English" },
  { code: "french", label: "French", native: "Français" },
  { code: "german", label: "German", native: "Deutsch" },
  { code: "hindi", label: "Hindi", native: "हिन्दी" },
  { code: "italian", label: "Italian", native: "Italiano" },
  { code: "japanese", label: "Japanese", native: "日本語" },
  { code: "korean", label: "Korean", native: "한국어" },
  { code: "malayalam", label: "Malayalam", native: "മലയാളം" },
  { code: "portuguese", label: "Portuguese", native: "Português" },
  { code: "spanish", label: "Spanish", native: "Español" },
  { code: "tamil", label: "Tamil", native: "தமிழ்" },
  { code: "telugu", label: "Telugu", native: "తెలుగు" },
  { code: "turkish", label: "Turkish", native: "Türkçe" },
  { code: "vietnamese", label: "Vietnamese", native: "Tiếng Việt" },
];

const TranslateDialog = ({
  open,
  onClose,
  language,
  setLanguage,
  onLanguageChange,
}) => {
  const currentLanguage =
    languages.find((lang) => lang.code === language) || languages[4]; // Default to English

  const handleLanguageChange = (event, newValue) => {
    if (newValue) {
      setLanguage(newValue.code);
      if (onLanguageChange) {
        onLanguageChange(newValue.code);
      }
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        className: "custom-dialog",
        sx: {
          minWidth: "320px",
          maxWidth: "420px",
          borderRadius: "16px",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
          overflow: "hidden",
        },
      }}
    >
      <DialogContent sx={{ p: 3 }}>
        <Typography
          variant="h6"
          sx={{ mb: 2, fontWeight: 600, color: "#1a1a1a" }}
        >
          Select Language
        </Typography>
        <FormControl fullWidth>
          <Autocomplete
            value={currentLanguage}
            onChange={handleLanguageChange}
            options={languages}
            getOptionLabel={(option) => `${option.label} (${option.native})`}
            renderOption={(props, option) => (
              <Box component="li" {...props} sx={{ py: 1.5 }}>
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}
                >
                  <Typography sx={{ fontWeight: 500, color: "#1a1a1a" }}>
                    {option.label}
                  </Typography>
                  <Typography sx={{ fontSize: "0.875rem", color: "#666" }}>
                    {option.native}
                  </Typography>
                </Box>
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder="Search language..."
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "12px",
                    backgroundColor: "#f5f5f5",
                    "&:hover": {
                      backgroundColor: "#f0f0f0",
                    },
                    "&.Mui-focused": {
                      backgroundColor: "#ffffff",
                      boxShadow: "0 0 0 2px rgba(25, 118, 210, 0.1)",
                    },
                  },
                  "& .MuiOutlinedInput-input": {
                    padding: "12px 16px",
                  },
                }}
              />
            )}
            ListboxProps={{
              sx: {
                maxHeight: "320px",
                padding: "8px",
                "&::-webkit-scrollbar": {
                  width: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                  borderRadius: "4px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#888",
                  borderRadius: "4px",
                  "&:hover": {
                    background: "#555",
                  },
                },
              },
            }}
          />
        </FormControl>
      </DialogContent>
    </Dialog>
  );
};

export default TranslateDialog;
